import React from "react";
import Typography from "@mui/material/Typography";

const ServerDescription = ({ description }) => (
    <Typography variant="body2" color="text.secondary" paragraph>
        {(description || "").split("\n").map((line, index) => (
            <React.Fragment key={index}>
                {line}
                <br />
            </React.Fragment>
        ))}
    </Typography>
);

export default ServerDescription;
